import clsx from "clsx";

import type { SpinnerProps } from "@proda-ai/ui-kit";
import { Spinner } from "@proda-ai/ui-kit";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

export type LoaderProps = JSX.IntrinsicAttributes &
    SpinnerProps & {
        sx?: BoxProps["sx"];
    };

export const testId = "Loader";
const Loader = (props: LoaderProps) => {
    const { sx, label, className, ...otherProps } = props;

    return (
        <Box
            sx={sx}
            component={Spinner}
            data-testid={testId}
            className={clsx(testId, className)}
            label={label}
            size="large"
            {...otherProps}
        />
    );
};

export default Loader;
